"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var usePageGroups = function usePageGroups(questionSet) {
  var _useState = (0, _react.useState)({}),
      pageGroups = _useState[0],
      setPageGroups = _useState[1];

  (0, _react.useEffect)(function () {
    var groups = (questionSet === null || questionSet === void 0 ? void 0 : questionSet.reduce(function (acc, question) {
      var page = question.data.page;

      if (!acc[page]) {
        acc[page] = {
          questions: [],
          pageNumber: page
        };
      }

      acc[page].questions.push(question);
      return acc;
    }, {})) || {};
    setPageGroups(groups);
  }, [questionSet]);
  return pageGroups;
};

var _default = exports["default"] = usePageGroups;